import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

import {
  ChangesPoliciesAbsractComponent
} from '@app/modules/shared/policies-detail/abstracts/changes-policies.abstract';
import { TranslocoService } from '@jsverse/transloco';
import { CurrencyFormatPipe } from '@app/pipes/currency-format.pipe';

@Component({
  selector: 'app-no-show-policies',
  templateUrl: './no-show-policies.component.html',
  styleUrls: ['../changes-policies.abstract.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NoShowPoliciesComponent extends ChangesPoliciesAbsractComponent {

  @Input()
  public isLast: boolean = false;

  constructor(public translateService: TranslocoService,
    public currencyFormat: CurrencyFormatPipe) {
    super(translateService, currencyFormat);
  }

  public buildLabelForNoShow(): string {

    const labelNoShow = this.translateService.translate(this.getLabelByNoShow(this.flight?.NoShow));
    const detailedLabelNoShowBefore = `${this.labelForChangesBefore} ${labelNoShow}`;

    const labelNoShowAfter = this.translateService.translate(this.getLabelByNoShow(this.flight?.NoShowAfter));
    const detailedLabelNoShowAfter = ` ${this.laberForChangesAfter} ${labelNoShowAfter}`;

    return this.flight?.NoShow === this.flight?.NoShowAfter ? `${labelNoShow}`
      : `${detailedLabelNoShowBefore} ${detailedLabelNoShowAfter}`;

  }

  private getLabelByNoShow(NoShow: number): string {
    switch (NoShow) {
      case 0:
        return 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.NO_SHOW_TEXT_ZERO_VALUE';
      case 1:
        return 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.NO_SHOW_TEXT';
      case 2:
        return 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.NO_SHOW_TEXT_REIMBURSEMENT';
      case 3:
        return 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.NO_SHOW_TEXT_CHANGES';
      case 4:
        return 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.NO_SHOW_ASK_AIRLINE';
      default:
        return 'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.NO_SHOW_TEXT_ZERO_VALUE';
    }
  }

}
